// extracted by mini-css-extract-plugin
module.exports = {"AgentLogsPageTable":"AgentLogsPage_AgentLogsPageTable__1tRnl"};